<template>
  <v-dialog v-model="dialog" max-width="700" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Formulir Pendaftaran</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
        <v-stepper v-model="step">
          <v-stepper-header style="box-shadow: none">
            <v-stepper-step :complete="step > 1" step="1"> Data DAPODIK </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2"> Data Kontak </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step === 3" step="3"> Selesai</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="py-0">
              <h2 class="black--text">Informasi Dasar</h2>
              <v-alert
                v-if="ptk.wkt_sinkron"
                icon="mdi-information"
                close-text="Tutup"
                colored-border
                border="left"
                type="info"
                class="bg-notif ma-0 my-2"
                color="yellow darken-2"
              >
                Data DAPODIK update terakhir pada tanggal
                <strong>{{ $localDate(ptk.wkt_sinkron, false, true) }}</strong>
              </v-alert>
              <v-card class="mb-5 mt-2" outlined>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="6" class="mb-2">
                      <div class="mb-1">
                        <div class="label--text" style="line-height: 1rem">Nama Lengkap</div>
                        <div class="body-2 black--text"> {{ ptk.nama }} </div>
                      </div>
                    </v-col>
                    <template v-if="tipe === 'kasek'">
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Nama Sekolah Bertugas</div>
                          <div class="body-2 black--text"> {{ $getDeepObj(sekolah, 'nama') }} </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">NUPTK</div>
                          <div class="body-2 black--text"> {{ ptk.nuptk || '-' }} </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">NPSN Sekolah Bertugas</div>
                          <div class="body-2 black--text"> {{ $getDeepObj(sekolah, 'npsn') }} </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Jabatan</div>
                          <div class="body-2 black--text"> {{ $getDeepObj(kasek, 'm_tugas.keterangan') || '-' }} </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Jenjang</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(sekolah, 'm_jenjang.singkat') || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Status Pegawai</div>
                          <div class="body-2 black--text">
                            {{ [6, 7, 8, 9].indexOf(+ptk.k_pegawai) > -1 ? 'PNS' : 'NON PNS' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Kota/Kabupaten</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(sekolah, 'm_kota.keterangan') }} -
                            {{ $getDeepObj(sekolah, 'm_kota.m_propinsi.keterangan') }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Mapel Yang Diampu</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(ptk, 'm_mapel_ukg.keterangan') || '-' }}
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <template v-if="tipe === 'pa'">
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Nama Sekolah Satminkal</div>
                          <div class="body-2 black--text"> {{ $getDeepObj(ptk, 'ptk_sekolah.sekolah.nama') }} </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Pendidikan Terakhir</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(ptk, 'm_kualifikasi.keterangan') || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Jenjang Sekolah Satminkal</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(ptk, 'ptk_sekolah.sekolah.m_jenjang.keterangan') || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Jabatan</div>
                          <div class="body-2 black--text">
                            {{
                              $fkata(($getDeepObj(ptk, 'ptk_jabatan_dapodiks') || []).map((item) => item.keterangan))
                            }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Kota/Kabupaten Sekolah Satminkal</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(ptk, 'ptk_sekolah.sekolah.m_kota.keterangan') }} -
                            {{ $getDeepObj(ptk, 'ptk_sekolah.sekolah.m_kota.m_propinsi.keterangan') }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Tugas Tambahan</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(details, 'm_tugas.keterangan') || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Nama Sekolah Bertugas</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(details, 'sekolah.nama') || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Jenjang Sekolah Bertugas</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(details, 'sekolah.m_jenjang.keterangan') || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Kota/Kabupaten Sekolah Bertugas</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(details, 'sekolah.m_kota.keterangan') }} -
                            {{ $getDeepObj(details, 'sekolah.m_kota.m_propinsi.keterangan') }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Instansi Tugas</div>
                          <div class="body-2 black--text">
                            {{ $getDeepObj(ptk, 'ptk_tugas.instansi.nama') }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" class="mb-2" v-if="$getDeepObj(ptk, 'pengampus_wi_aktif').length">
                        <div class="mb-1">
                          <div class="label--text" style="line-height: 1rem">Status WI</div>
                          <div class="body-2 black--text">
                            Widyaiswara di {{ $getDeepObj(ptk, 'pengampus_wi_aktif.0.instansi.nama') }}
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
              <div class="body-2 pb-4">
                Pastikan data di atas telah sesuai dangen data DAPODIK anda saat ini.
                <strong>Apakah Data tersebut sesuai dengan data DAPODIK Anda?</strong>
              </div>
            </v-stepper-content>
            <v-stepper-content step="2" class="py-0">
              <h2 class="black--text">Informasi Kontak</h2>
              <p class="black--text pa-0 ma-0">
                Lengkapi informasi dasar Anda pada form yang tersedia. Pastikan
                <strong>Nomor Telepon Anda Aktif dan menggunakan email yang valid</strong>
              </p>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container class="pa-0 py-2">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-subheader class="px-0 body-2 secondary--text" style="height: 24px">
                        No.Telepon (Terhubung WA)*
                      </v-subheader>
                      <v-text-field
                        dense
                        single-line
                        :rules="[(v) => !!v || 'No.Telepon wajib diisi']"
                        v-mask="'###############'"
                        type="text"
                        label="No.Telepon (Terhubung WA)"
                        required
                        outlined
                        v-model="form.no_wa"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-subheader class="px-0 body-2 secondary--text" style="height: 24px"> Email* </v-subheader>
                      <v-text-field
                        dense
                        single-line
                        :rules="[
                          (v) => !!v || 'Alamat surel wajib diisi',
                          (v) => /.+@.+/.test(v) || 'Alamat surel harus valid',
                        ]"
                        type="text"
                        label="Alamat Surel"
                        required
                        outlined
                        v-model="form.alt_email"
                    /></v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-stepper-content>
            <v-stepper-content step="3" class="py-0">
              <div class="text-center">
                <v-icon color="green" size="80">mdi-check-decagram</v-icon>
                <h2 class="py-2 black--text">Selamat!! Pendaftaran Berhasil</h2>
                <p class="py-5 body-2">
                  Selamat! Pendaftaran Anda berhasil, Silahkan mengikuti setiap tahap seleksi!
                </p>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row no-gutters v-if="step === 1">
          <v-col cols="12" class="px-4">
            <div class="text-right">
              <v-btn olor="warning" class="mr-2" color="error" elevation="0" right dark @click="onBack">
                <v-icon left dark> mdi-close </v-icon>
                Tidak
              </v-btn>
              <v-btn color="info" elevation="0" @click="onNext" :disabled="isPraktisi && (!!warning || !form.k_kota)">
                <v-icon left dark> mdi-check </v-icon>
                Ya
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <template v-else-if="step === 2">
          <v-btn text class="mr-2" color="grey" right dark @click="onBack" v-if="step === 2">
            <v-icon left dark color="grey darken-2"> mdi-arrow-left </v-icon>
            <div class="grey--text text--darken-2">Kembali</div>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-btn
              :text="step > 1"
              class="mr-2"
              :color="step === 1 ? 'error' : 'grey'"
              elevation="0"
              right
              dark
              @click="close"
            >
              <div class="grey--text text--darken-2">Batal</div>
            </v-btn>
            <v-btn color="info" elevation="0" @click="onNext" :disabled="!!warning">
              <v-icon left dark> mdi-check </v-icon>
              {{ step === 1 ? 'Ya' : 'Simpan' }}
            </v-btn>
          </div>
        </template>
        <template v-else>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-btn color="info" elevation="0" @click="finish">OK</v-btn>
          </div>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PopupDaftarInfo',
  props: {
    details: {
      type: Object,
      default: () => {},
    },
    tipe: {
      type: String,
      default: 'kasek',
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      angkatan: 1,
      step: 1,
      warning: null,
      isPraktisi: false,
      form: {},
    };
  },
  computed: {
    ptk() {
      return this.details?.ptk ?? {};
    },
    kasek() {
      return this.details?.kasek ?? {};
    },
    sekolah() {
      return this.details?.kasek?.sekolah ?? {};
    },
  },
  methods: {
    ...mapActions('preferensi', ['daftar']),

    open(data) {
      this.$set(this.form, 'no_wa', '');
      this.$set(this.form, 'alt_email', '');
      this.$set(this.form, 'k_unsur_psp', (data && data.k_unsur_psp) || '');
      this.step = 1;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    finish() {
      this.$emit('reload');
      this.close();
    },

    onBack() {
      if (this.step === 1) {
        this.$notifikasi(
          [
            '<h2 class="body-2 black--text my-3">Data DAPODIK Tidak Sesuai</h2>',
            '<p class="black--text body-2">' +
              'Data Anda saat ini yang terhubung dengan <b>DAPODIK belum sesuai</b>. Segera lakukan ' +
              '<b>Perbarui Data</b> Anda sesuai dengan data terbaru.</p>',
            '<p class="black--text body-2">' +
              'Anda dapat melakukan perubahan data dapodik melalui <b>Operator Sekolah</b> atau <b>Operator Dinas</b>. ' +
              'Apabila data sudah termutahirkan di dapodik maka otomatis di SIMPKB akan ikut berubah.</p>',
            '<p class="black--text body-2">Estimasi waktu update di dapodik adalah <b>maksimal 2x24 jam</b> ' +
              'setelah operator melakukan perubahan</p>',
            '<p class="black--text body-2"><strong>Jika data telah diperbaiki dan valid, silakan ulangi proses pendaftaran</strong></p>',
          ].join(''),
          'Informasi',
          { btnColor: 'secondary' }
        );
        return;
      }
      this.step -= 1;
    },

    onNext() {
      switch (this.step) {
        case 1:
          this.step += 1;
          break;
        case 2:
          if (!this.$refs.form.validate()) return;
          this.onDaftar();
          break;
      }
    },

    onDaftar() {
      this.daftar({ tipe: this.tipe, params: this.form })
        .then(() => {
          this.step += 1;
        })
        .catch((err) => {
          this.$error(err);
        });
    },
  },
};
</script>
